import * as React from "react";
import type { SVGProps } from "react";
const SvgPaperclip02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={2}
      d="m18.957 11.505-7.045 7.045c-1.918 1.918-4.794 2.145-6.75.19-1.917-1.918-1.667-4.696.288-6.652l7.92-7.92a3.087 3.087 0 0 1 4.375 0 3.087 3.087 0 0 1 0 4.376l-8.059 8.06a1.547 1.547 0 1 1-2.188-2.189l7.185-7.184"
    />
  </svg>
);
export default SvgPaperclip02;
